import getSourceElements, { ImageType } from 'libs/client/Image/getSourceElements';

import {
  ContentWrapper,
  PhotoLinkWrapper,
  PhotoWrapper,
  StyledHeader,
  StyledImage,
  StyledLinkV2,
  StyledPicture,
  TileWrapper,
} from './PartnerTile.styles';

export type PartnerTileProps = {
  images: ImageType;
  featuredImageSrc: string;
  imgAlt: string;
  hed: string;
  dek: React.ReactNode;
  link?: {
    href: string;
    text: string;
  };
};

const PartnerTile: React.FC<PartnerTileProps> = ({
  images,
  featuredImageSrc,
  imgAlt,
  hed,
  dek,
  link,
}): JSX.Element => {
  const PhotoWrapperComponent = link?.href ? PhotoLinkWrapper : PhotoWrapper;

  return (
    <TileWrapper>
      <PhotoWrapperComponent href={link?.href}>
        <StyledPicture>
          {getSourceElements(images.webp, 'webp', true)}
          {getSourceElements(images.jpg, 'jpg', true)}
          <StyledImage src={featuredImageSrc} alt={imgAlt} />
        </StyledPicture>
      </PhotoWrapperComponent>

      <ContentWrapper>
        <StyledHeader>{hed}</StyledHeader>
        <div>{dek}</div>
        {link && (
          <StyledLinkV2 inline href={link.href}>
            {link.text}
          </StyledLinkV2>
        )}
      </ContentWrapper>
    </TileWrapper>
  );
};

export default PartnerTile;
